var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"segmented-control",attrs:{"role":"tablist"}},_vm._l((_vm.options),function(option,index){return _c('button',{key:index,class:[
      'segmented-control__button',
      { 'segmented-control__button--active': index === _vm.activeIndex },
    ],attrs:{"id":_vm.getTabId(index),"role":"tab","aria-selected":String(index === _vm.activeIndex),"aria-controls":_vm.panelId,"tabindex":index === _vm.activeIndex ? 0 : -1},on:{"click":function($event){return _vm.$emit('change', index)}}},[_vm._v("\n    "+_vm._s(option)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }